import { useUserCountry } from "@src/packages/location/useUserCountry";

export type Region = "US" | "FR" | "UK";

/**
 * The user's region — drives feature availability (the US-only cost tools) and
 * region-specific content.
 *
 * Region follows the patient's profile COUNTRY (`useUserCountry`), NOT the app
 * language and NOT the device. Language and country are independent: a
 * French-speaking patient living in the US should still get the US
 * experience, and an English speaker living in France should be gated to the
 * FR experience.
 *
 * Null while the profile is still loading, so a gate shows nothing for that
 * moment instead of the wrong country. Mapping once loaded: US → US, GB → UK,
 * any other country → FR (the non-US bucket the cost screens gate against).
 * A profile with no country at all answers US, so a failed sign-in default
 * never locks the tools away.
 */
export function useRegion(): Region | null {
  const { countryCode, isLoading } = useUserCountry();

  if (isLoading) return null;
  if (!countryCode || countryCode === "US") return "US";
  if (countryCode === "GB") return "UK";
  return "FR";
}
